import { axios, axios2 } from '@/lib/axios';
export type ResendOtp = {
  email: string;
};

export const resendAgencyOtp = (data: ResendOtp) => {
  return axios2.post(`agency-api/agency-register-resend`, data);
};
